import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-upload";
function ConfigurationItemEvaluationTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(20);
    self.PageSize.subscribe(function () {
        if (self.PageIndex() == 0) {
            self.RefreshGrid();
        }
        else {
            self.PageIndex(0);
        }
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.EvaluationCollection = ko.observableArray([]);
    self.AdditionalColumns = ko.observableArray([]);
    self.SelectRow = function (item) {
        self.SelectedEvaluationRow(item);
        return true;
    };
    self.SelectedEvaluationRow = ko.observable({});
    self.SelectedEvaluationRow.subscribe(function () {
        if (self.SelectedEvaluationRow() == null) {
            self.enableDisableButton("EditConfigurationItemEvaluation", false);
            self.enableDisableButton("DeleteConfigurationItemEvaluation", false);
        }
        else {
            self.enableDisableButton("EditConfigurationItemEvaluation", true);
            self.enableDisableButton("DeleteConfigurationItemEvaluation", Bao.Utils.String.IsNullOrWhitespace(self.SelectedEvaluationRow().CompleteDateJs));
        }
    });
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteConfigurationItemEvaluation");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemEvaluation":
                self.ShowCreateEvaluationDialog(self.ConfigurationItem.ConfigurationItemId());
                break;
            case "EditConfigurationItemEvaluation":
                if (self.SelectedEvaluationRow() != null) {
                    self.EditConfigurationItemEvaluation(self.SelectedEvaluationRow());
                }
                break;
            case "DeleteConfigurationItemEvaluation":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemEvaluation(self.SelectedEvaluationRow());
                    }
                });
                break;
            case "RefreshConfigurationItemEvaluation":
                self.RefreshGrid();
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemEvaluationCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedEvaluationRow(null);
            self.TotalRows(0);
            self.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.EvaluationCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.CreateEvaluation = function (folderStructureChecklistId, configurationItemId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/CreateEvaluationByConfigurationItem", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            configurationItemId: configurationItemId
        }), function (result) {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            tabPage.IsLoading(false);
        });
    };
    self.DeleteConfigurationItemEvaluation = function (item) {
        Bao.post("ConfigurationItemTab/DeleteConfigurationItemEvaluation", JSON.stringify({
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            evaluationId: ko.unwrap(item.EvaluationId)
        }), function () {
            self.RefreshGrid();
        });
    };
    self.EditConfigurationItemEvaluation = function (item) {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };
    self.ShowCreateEvaluationDialog = function (configurationItemId) {
        window.baorequire(["ViewModels/Dialogs/CreateEvaluationDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show();
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == true) {
                    self.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), self.ConfigurationItem.ConfigurationItemId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        var def = $.Deferred();

        self.SetColumns().then(function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        
        return def.promise();
    };
    self.Save = function () { };
    self.loaded = function () {
        return self.Refresh();
    };
    // Returns value for dynamic column
    self.GetValueForAdditionalColumn = function (matchCode, item) {
        if (item.ExtendedColumnValues !== undefined) {
            for (var n = 0; n < item.ExtendedColumnValues.length; n++) {
                if (item.ExtendedColumnValues[n].Key === matchCode) {
                    return item.ExtendedColumnValues[n].Value;
                }
            }
        }
        return "";
    };

    // Sets dynamic Columns
    self.SetColumns = function () {
        return Bao.post("ConfigurationItemTab/GetAdditionalColumns", JSON.stringify({
            configurationItemId: self.ConfigurationItem.ConfigurationItemTypeId()
        })).then(function (result) {
            self.AdditionalColumns(result.AdditionalColumns);
        });
    };
}
;
Bao.inherit(ConfigurationItemEvaluationTabModel, ChildTabViewModel);
export default ConfigurationItemEvaluationTabModel;